import SubMenu from './SubMenu';

export default class Menu {
	constructor(elm) {
		this.elm = elm;

		this.animating = false;

		this.itemsWithChildren = this.elm.querySelectorAll('.menu-item-has-children');
		this.submenus = [];

        this.itemsWithChildren.forEach(item => {
			this.submenus.push(new SubMenu(item, this));
        });

	}

	closeSubmenus() {
		this.submenus.forEach(elm => {
			if(elm.open) {
				elm.closeDetails();
			}
		});
	}
}